var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnFavorite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "icn-favorite_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h20v20H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icn-favorite_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.518 15.861a1.373 1.373 0 01-.433-.27l-.99-.9c-1.518-1.348-2.844-2.65-3.977-3.908-1.134-1.258-1.7-2.588-1.7-3.99 0-1.1.377-2.02 1.13-2.762.754-.742 1.69-1.113 2.807-1.113.647 0 1.288.148 1.92.444.634.296 1.21.8 1.726 1.51.545-.71 1.13-1.214 1.752-1.51a4.36 4.36 0 011.887-.444c1.118 0 2.055.37 2.81 1.113.757.742 1.135 1.662 1.135 2.762 0 1.418-.58 2.76-1.74 4.026a55.386 55.386 0 01-3.938 3.863l-.997.91a1.357 1.357 0 01-.437.27 1.376 1.376 0 01-.955 0zm-.033-9.828c-.381-.687-.842-1.197-1.382-1.53A3.263 3.263 0 006.355 4c-.815 0-1.495.264-2.038.792-.544.528-.816 1.197-.816 2.008 0 .65.209 1.322.626 2.017.417.695.941 1.392 1.571 2.093.63.7 1.315 1.38 2.054 2.04.739.66 1.433 1.28 2.081 1.856a.245.245 0 00.168.064c.065 0 .12-.02.169-.064.648-.577 1.342-1.195 2.08-1.856.74-.66 1.424-1.34 2.054-2.04a13.67 13.67 0 001.572-2.093c.417-.695.625-1.367.625-2.017 0-.81-.271-1.48-.815-2.008-.544-.528-1.223-.792-2.039-.792-.625 0-1.21.167-1.758.501-.547.334-1.011.844-1.393 1.531a.42.42 0 01-.204.23.649.649 0 01-.292.07.709.709 0 01-.3-.07.413.413 0 01-.215-.23z",
    fill: "#fff"
  }))));
}
export default SvgIcnFavorite;